export default __webpack_public_path__ + "static/media/4-Stadium-BAKU-Benjamin-Proulx-Mathers-Christian-Lagueux-YUL-MUSIC-Montreal-Composer.39fcb5d3.jpg";